/** PROTOTYPE: price every spread in parallel -- THROWAWAY.
 *  Each probe drives one spread's engine price through the shared useSpreadPrice
 *  hook, so it keeps its own debounce and cancellation. It renders nothing and
 *  reports its state up. Because each spread has its own probe, a slow or failed
 *  spread never blocks the others, and only the spread that changed refetches. */
import React, { useEffect } from 'react';
import { ProjectState, Spread } from './spreadSplitData';
import { useSpreadPrice, SpreadPriceState } from './useSpreadPrice';
import { WeldMode } from './spreadPricingApi';

export type OnSpreadState = (id: string, state: SpreadPriceState) => void;

interface ProbeProps {
  project: ProjectState; spread: Spread; mode: WeldMode; mobilizing: boolean; onState: OnSpreadState;
}

const SpreadPriceProbe: React.FC<ProbeProps> = ({ project, spread, mode, mobilizing, onState }) => {
  const state = useSpreadPrice(project, spread, mode, mobilizing);
  useEffect(() => { onState(spread.id, state); }, [spread.id, state, onState]);
  return null;
};

interface ProbesProps {
  project: ProjectState; mode: WeldMode; mobilizing: boolean; onState: OnSpreadState;
}

/** One probe per spread, keyed by id so each keeps its own price lifecycle. */
export const SpreadPriceProbes: React.FC<ProbesProps> = ({ project, mode, mobilizing, onState }) => (
  <>
    {project.spreads.map((s) => (
      <SpreadPriceProbe key={s.id} project={project} spread={s} mode={mode} mobilizing={mobilizing} onState={onState} />
    ))}
  </>
);
